<script setup lang="ts">
/** Bearings of the teeth, evenly spaced. */
const GEAR_TEETH = [0, 45, 90, 135, 180, 225, 270, 315] as const;
</script>

<template>
  <svg class="gear-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <rect
      v-for="angle in GEAR_TEETH"
      :key="angle"
      x="10.6"
      y="0.9"
      width="2.8"
      height="4.9"
      rx="0.7"
      fill="currentColor"
      :transform="`rotate(${angle} 12 12)`"
    />
    <circle cx="12" cy="12" r="7" fill="none" stroke="currentColor" stroke-width="2.8" />
    <circle cx="12" cy="12" r="2.5" fill="none" stroke="currentColor" stroke-width="1.5" />
  </svg>
</template>

<style scoped>
.gear-icon {
  /* Never shrink to the space left over: the drawing's size is the caller's
     decision, and a squashed gear stops reading as a gear. */
  flex: none;
  display: block;
  /* The teeth are what make it read as a gear at this size, so a caller that
     turns it on hover turns the drawing about its own centre and nothing else
     moves. */
  transition: transform 220ms ease, color 120ms ease;
}
</style>
